// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IGVrm{position:relative;height:24px}.YOhgc{aspect-ratio:16/9;height:24px;object-fit:contain}.ssqmc{visibility:hidden;width:0;height:0}.TfnrP{display:flex;align-items:center;color:#696992}.PMzqG{width:43px;height:24px;display:flex;align-items:center;justify-content:center}.xdaT5{display:flex;flex:0 0 auto;justify-content:center}.apcm3{display:flex;flex-direction:column;text-align:left}.sZUjJ{flex:1 1 auto}.FEM8I{display:flex}.Gv2fg{padding:12px 0}.rsUfY{display:flex;align-items:center}.nTvyv{width:100%;height:1px;background:var(--dark-120, #E4E4EC);margin:8px}.YOKap{display:flex;flex-direction:row;align-items:center;gap:4px;height:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"logo": `IGVrm`,
	"logoImage": `YOhgc`,
	"loadingLogoImage": `ssqmc`,
	"currentBusinessViewOnly": `TfnrP`,
	"companyLogoPlaceholder": `PMzqG`,
	"imageAsideText": `xdaT5`,
	"accountDescription": `apcm3`,
	"viewOnlyText": `sZUjJ`,
	"trigger": `FEM8I`,
	"popover": `Gv2fg`,
	"selectableItem": `rsUfY`,
	"separator": `nTvyv`,
	"createNewLabel": `YOKap`
};
export default ___CSS_LOADER_EXPORT___;
